import { render } from "./DeviceSegments.vue?vue&type=template&id=80b69110&scoped=true"
import script from "./DeviceSegments.vue?vue&type=script&lang=js"
export * from "./DeviceSegments.vue?vue&type=script&lang=js"

import "./DeviceSegments.vue?vue&type=style&index=0&id=80b69110&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b69110"]])

export default __exports__